var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile())?_c('b-button',{staticClass:"ovr-button show-tour__button",on:{"click":function($event){return _vm.$emit('handleClick')}}},[_vm._v(" Show tour ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }